// extracted by mini-css-extract-plugin
export default {"container":"Kl-z","freeShip":"Ll-z","privacy":"Ml-z"};